// initial state
const state = {
    list: jsonData.socials.list,
}

// getters
const getters = {
}

// actions
const actions = {}

// mutations
const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
